/**
 * 按需引入 echarts 需要用到什么模块，就引入什么模块
 */
// eslint-disable-next-line no-undef
const echarts = equire([
  'line',
  'bar',
  'pie',
  'title',
  'legend',
  'legendScroll',
  'tooltip'
])
export default echarts
